"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPolygonsInAreaAreasPolygonsGetRequest$ = exports.GetPolygonsInAreaAreasPolygonsGetRequest$outboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetRequest$inboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetSecurity$ = exports.GetPolygonsInAreaAreasPolygonsGetSecurity$outboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetSecurity$inboundSchema = void 0;
exports.getPolygonsInAreaAreasPolygonsGetSecurityToJSON = getPolygonsInAreaAreasPolygonsGetSecurityToJSON;
exports.getPolygonsInAreaAreasPolygonsGetSecurityFromJSON = getPolygonsInAreaAreasPolygonsGetSecurityFromJSON;
exports.getPolygonsInAreaAreasPolygonsGetRequestToJSON = getPolygonsInAreaAreasPolygonsGetRequestToJSON;
exports.getPolygonsInAreaAreasPolygonsGetRequestFromJSON = getPolygonsInAreaAreasPolygonsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const shared = __importStar(require("../shared/index.js"));
/** @internal */
exports.GetPolygonsInAreaAreasPolygonsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPolygonsInAreaAreasPolygonsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPolygonsInAreaAreasPolygonsGetSecurity$;
(function (GetPolygonsInAreaAreasPolygonsGetSecurity$) {
    /** @deprecated use `GetPolygonsInAreaAreasPolygonsGetSecurity$inboundSchema` instead. */
    GetPolygonsInAreaAreasPolygonsGetSecurity$.inboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetSecurity$inboundSchema;
    /** @deprecated use `GetPolygonsInAreaAreasPolygonsGetSecurity$outboundSchema` instead. */
    GetPolygonsInAreaAreasPolygonsGetSecurity$.outboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetSecurity$outboundSchema;
})(GetPolygonsInAreaAreasPolygonsGetSecurity$ || (exports.GetPolygonsInAreaAreasPolygonsGetSecurity$ = GetPolygonsInAreaAreasPolygonsGetSecurity$ = {}));
function getPolygonsInAreaAreasPolygonsGetSecurityToJSON(getPolygonsInAreaAreasPolygonsGetSecurity) {
    return JSON.stringify(exports.GetPolygonsInAreaAreasPolygonsGetSecurity$outboundSchema.parse(getPolygonsInAreaAreasPolygonsGetSecurity));
}
function getPolygonsInAreaAreasPolygonsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPolygonsInAreaAreasPolygonsGetSecurity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPolygonsInAreaAreasPolygonsGetSecurity' from JSON`);
}
/** @internal */
exports.GetPolygonsInAreaAreasPolygonsGetRequest$inboundSchema = z.object({
    "filter[title_type]": z.array(shared.TitleType$inboundSchema).optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[title_type]": "filterTitleType",
    });
});
/** @internal */
exports.GetPolygonsInAreaAreasPolygonsGetRequest$outboundSchema = z.object({
    filterTitleType: z.array(shared.TitleType$outboundSchema).optional(),
    page: z.number().int().default(1),
    point: z.array(z.string()),
    radius: z.number().int().optional(),
    results: z.number().int().default(25),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterTitleType: "filter[title_type]",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPolygonsInAreaAreasPolygonsGetRequest$;
(function (GetPolygonsInAreaAreasPolygonsGetRequest$) {
    /** @deprecated use `GetPolygonsInAreaAreasPolygonsGetRequest$inboundSchema` instead. */
    GetPolygonsInAreaAreasPolygonsGetRequest$.inboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetRequest$inboundSchema;
    /** @deprecated use `GetPolygonsInAreaAreasPolygonsGetRequest$outboundSchema` instead. */
    GetPolygonsInAreaAreasPolygonsGetRequest$.outboundSchema = exports.GetPolygonsInAreaAreasPolygonsGetRequest$outboundSchema;
})(GetPolygonsInAreaAreasPolygonsGetRequest$ || (exports.GetPolygonsInAreaAreasPolygonsGetRequest$ = GetPolygonsInAreaAreasPolygonsGetRequest$ = {}));
function getPolygonsInAreaAreasPolygonsGetRequestToJSON(getPolygonsInAreaAreasPolygonsGetRequest) {
    return JSON.stringify(exports.GetPolygonsInAreaAreasPolygonsGetRequest$outboundSchema.parse(getPolygonsInAreaAreasPolygonsGetRequest));
}
function getPolygonsInAreaAreasPolygonsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPolygonsInAreaAreasPolygonsGetRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetPolygonsInAreaAreasPolygonsGetRequest' from JSON`);
}
//# sourceMappingURL=getpolygonsinareaareaspolygonsget.js.map